export default {
  TITLE: '社区准则',
  CONTENT: `
    <p class="p-t-24">
      社区准则的目的是为亚马逊社区保持有帮助、相关、有意义和适当的信息
    </p>
    <p>
      社区是与其他用户分享您的想法和经历（正面和负面）的地方。以下准则解释了社区允许和不允许发布的内容。
    </p>
    <p>
      使用社区功能，即表示您已同意我们的<a data-path="termStatement" data-title="USE_CONDITION">使用条件</a>和
      <a data-path="termStatement" data-title="PRIVACY_STATEMENT" >隐私声明</a>。您还同意遵守这些指南，我们会不时更新这些指南。社区功能包括
    </p>
    <ul>
      <li>评论（包括星级）</li>
      <li>有帮助的投票</li>
      <li>个人资料页面</li>
      <li>亚马逊关注</li>
      <li>亚马逊数字和设备论坛</li>
      <li>关于违规行为的举报</li>
    </ul>
    <h3>准则适用于什么</h3>
    <ul>
      <li>您的社区行为，包括：</li>
      <ul class="circle-format">
        <li>分享文字、照片、视频、链接</li>
        <li>将评论标记为 “有帮助的”</li>
      </ul>
      <li>与其他社区成员以及亚马逊的互动</li>
      <li>
        该指南不适用于在亚马逊上销售的商品或服务中的内容（例如：图书内容）。
      </li>
    </ul>
    <h3>谁可以参加</h3>
    <p>如果您有亚马逊账户，则可以：</p>
    <ul>
      <li>创建和更新购物清单、愿望清单和礼品清单</li>
      <li>更新您的个人资料页面</li>
      <li>参加数码和设备论坛</li>
    </ul>
    <P>要执行以下任何操作，您需要在过去 12 个月内使用有效的信用卡或借记卡在 Amazon.cn 上花费至少20元人民币：</P>
    <ul>
      <li>发表评论（包括星级）</li>
      <li>提交有帮助的投票</li>
      <li>关注其他用户</li>
    </ul>
    <P>促销折扣不计入20元人民币的最低消费要求。</P>
    <h3>什么不允许？</h3>
    <p>卖家、订单或配送反馈</p>
    <p>我们不允许评论聚焦于以下内容：</p>
    <ul>
      <li>卖家及其提供的客户服务</li>
      <li>订购问题和退货</li>
      <li>配送包装</li>
      <li>商品状况和残损</li>
      <li>配送费用和速度</li>
    </ul>
    <p>
      为什么不允许？
      社区内容旨在帮助客户了解商品本身，而不是某人的个人订购体验。也就是说，我们绝对希望了解您对卖家和包装的反馈，而不是在评论中提供反馈。
    </p>
    <h3>关于定价和供货情况的评论</h3>
    <p>
      如果您的评论与商品的价值相关即可进行评论（例如： “仅售100人民币，这款搅拌机真的很棒。“ 不允许发表与个人体验相关的定价评论。例如，不要比较不同商店中同一商品的价格： “在这里找到这件商品的价格比我在当地的商店便宜 5 人民币。“ 这样的评论是不允许的，因为该评论并非与所有用户都相关。
    </p>
    <p>
      关于产品货存性的一些评论是允许的。例如，你可以讨论尚未发布的产品形式： “我希望这本书也有平装版。” 但是，我们不允许对特定商店的货存情况发表评论。同样，社区的目的是为了帮助您与其他买家分享产品相关信息的反馈。
    </p>
    <h3>以不受支持的语言编写的内容</h3>
    <p>
      为确保内容有帮助性，我们仅允许您所访问的亚马逊网站所提供支持的语言编写内容。例如，我们不允许在Amazon.cn上以法语撰写的评论，因为该亚马逊仅支持中文和英语语言选择。某些亚马逊网站支持多种语言，但不允许使用多种语言编写的内容。
    </p>
    <h3>重复的文字、垃圾邮件、用符号创建的图片</h3>
    <p>在提供的内容中，我们不允许包含分散注意力的内容和垃圾邮件。这包括：</p>
    <ul>
      <li>多次重复的文字</li>
      <li>不含有任何意义的文字</li>
      <li>仅使用标点符号或其他符号的内容</li>
      <li>ASCII 艺术（用符号和字母创建的图片）</li>
    </ul>
    <h3>私人信息</h3>
    <p>请勿发布侵犯他人隐私或分享您个人信息的内容。这包括：</p>
    <ul>
      <li>电话号码</li>
      <li>电子邮件地址</li>
      <li>邮寄地址</li>
      <li>车牌号</li>
      <li>数据源名称 (DSN)</li>
      <li>订单号</li>
    </ul>
    <h3>亵渎、骚扰的内容</h3>
    <p>我们允许对他人的信念和专业知识具有尊重性的质疑。我们不允许：</p>
    <ul>
      <li>亵渎、淫秽、骂人。</li>
      <li>骚扰、威胁。</li>
      <li>关于危害儿童和青少年的人格的内容。</li>
      <li>攻击与您意见不同的人。</li>
      <li>侮辱、诽谤或煽动性内容。</li>
      <li>掩盖他人的意见。请不要从多个帐户或煽动他人发布相同言论。</li>
    </ul>
    <h3>仇恨言论</h3>
    <p>不允许基于以下特征对他人表达仇恨言论：</p>
    <ul>
      <li>种族</li>
      <li>民族或地域</li>
      <li>国籍</li>
      <li>性别</li>
      <li>性别认同</li>
      <li>性取向</li>
      <li>宗教</li>
      <li>年龄</li>
      <li>残疾</li>
    </ul>
    <p>同样也不允许宣传使用此类仇恨言论的组织。</p>
    <h3>色情内容</h3>
    <p>
      我们允许对在亚马逊上销售的色情和情趣商品进行讨论。带有色情内容的商品（书籍、电影）也是如此。但是我们仍然不允许亵渎或淫秽语言。我们也不允许包含裸露内容和露骨色情图片或相关描述的内容。
    </p>
    <h3>链接</h3>
    <p>
      我们允许链接到亚马逊上的其他商品，但不允许链接到外部网站。不要发布指向钓鱼或其他恶意软件网站的链接。
      我们不允许使用带有引荐来源标签或附属代码的网址。
    </p>
    <h3>广告、利益冲突、促销内容</h3>
    <p>
      如果内容的主要目的是宣传公司、网站、作者或特别优惠，我们不允许发布这样的内容。我们也不允许用户创建、编辑或发布与自己的商品或服务有关的内容。以下来源提供的商品和服务也是如此：。
    </p>
    <ul>
      <li>朋友们</li>
      <li>亲戚们</li>
      <li>雇主</li>
      <li>商业伙伴</li>
      <li>竞争对手</li>
    </ul>
    <p>
      我们不允许以促销形式撰写评论。例如，如果某人与商品有直接或间接的经济利益关系或其他任何利益冲突，我们会删除此人发布的评论。
    </p>
    <p>
      对于评论以外的社区内容，您可以发布与您有利益关系或密切个人关系的品牌、卖家、作者或艺术家的商品和服务，前提是您要清楚而明确地披露这种关系。示例："我写这篇文章拿到了报酬。"
      但是，品牌和企业在参与社区互动时，不能以任何将亚马逊客户转移到非亚马逊网站、服务、应用程序或渠道的方式，开展营销或销售交易。这包括广告、特别优惠或"行动号召"。对于品牌、卖家、作者或艺术家账户所发布的关于自己商品或服务的内容，不需要额外添加标签。
    </p>
    <h3>有偿评论</h3>
    <p>
      评论应诚实地反映您的观点。正因为如此，我们不允许为换取报酬而创建、编辑或删除评论。报酬包括现金、折扣、免费商品、礼品卡和退款。一些不允许内容的常见示例：
    </p>
    <ul>
      <li>
        您的订单在送达时，包装里有一张礼品卡。要兑换礼品卡，您必须先发表正面的评论。
      </li>
      <li>
        发表负面评论后，您收到了一封电子邮件，其中说明如果您更改或删除评论，则可以获得退款。
      </li>
      <li>
        您收到一条文本消息，承诺在您购买商品并发布评论后，会向您提供退款赔偿。
      </li>
    </ul>
    <p>
      例外情况：您可以对从作者或出版商处收到的免费或折扣图书（提前阅读本）进行评论。但是，他们不能以此来换取评论，也不能试图影响评论。
    </p>
    <h3>抄袭、侵权、冒名顶替</h3>
    <p>
      我们仅允许您发布自己的内容或您有权在亚马逊上使用的内容。这包括文字、图像和视频。不允许：
    </p>
    <ul>
      <li>
        发布侵犯他人知识产权（包括版权、商标、专利、商业机密）或其他专有权的内容
      </li>
      <li>以侵犯他人知识产权或所有权的方式与社区成员互动</li>
      <li>冒充某人或组织</li>
    </ul>
    <h3>非法和危险活动</h3>
    <p>不要发布鼓励非法活动的内容，例如：</p>
    <ul>
      <li>暴力</li>
      <li>非法使用药物</li>
      <li>未成年人饮酒</li>
      <li>虐待儿童或动物</li>
      <li>欺诈</li>
    </ul>
    <p>
      我们不允许宣传或威胁对自己或他人造成人身或经济伤害的内容。这包括恐怖主义。关于造成伤害的笑话或讽刺评论是不允许的。
    </p>
    <p>
      也不允许提供欺诈性商品、服务、促销或计划（快速赚钱、金字塔）。不要鼓励错误使用商品的危险行为。
    </p>
    <h3>违规行为的后果</h3>
    <p>
      违反我们的准则会使社区变得不在具备信赖性、安全性及实用性。如果有人违反了准则，我们将：
    </p>
    <ul>
      <li>删除其相关内容</li>
      <li>限制他们使用社区功能的权限</li>
      <li>移除相关商品</li>
      <li>暂停或终止他们的账户</li>
      <li>预扣付款</li>
    </ul>
    <p>
      如果我们发现不寻常的评论行为，我们可能会限制发布评论的权限。如果我们拒绝或删除某人的评论，因为它违反了我们的，我们将不再接受他们对同一商品的任何评论。
    </p>
    <p>
      如果违法相关法律法规的规定，我们可能会采取法律行动，并产生民事和刑事处罚。
    </p>
    <h3>如何举报违规行为</h3>
    <p>
      使用您要举报的内容旁边的 “报告滥用行为” 链接。如果没有 “报告滥用行为”链接，请发送电子邮件至community-email{'@'}amazon.cn。描述出您所举报内容的位置及您认为它违反了社区准则的原因。
    </p>
    <p>
      如果有人以提供报酬的形式请求您创建、编辑或发布违规内容，请将该请求发送至community-email{'@'}amazon.cn 。发送内容需包括：
    </p>
    <ul>
      <li>联系信息</li>
      <li>商品详情页面</li>
      <li>提供报酬的屏幕截图</li>
    </ul>
    <p>收到您的举报后，我们将进行调查并采取适当的措施。</p>
  `
};
